import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientHelper } from '../../../../../appServices/apiClient';

const COMMUNITIES_URL = 'communities';
const ACTIVE_PROJECTS_QUERY =
    '?filter[adminable]=true&filter[is_archived]=false&page[number]=1&page[size]=200&sort=name';

@Injectable({ providedIn: 'root' })
export class CommunityService {
    private readonly http = inject(HttpClientHelper);

    getCommunities(): Observable<unknown> {
        return this.http.get(COMMUNITIES_URL, 'admin');
    }

    getActiveProjects(params?: { search?: string; page?: number; perPage?: number }): Observable<unknown> {
        const page = params?.page ?? 1;
        const perPage = params?.perPage ?? 25;
        let query = `projects?filter[adminable]=true&filter[is_archived]=false&sort=name&page[number]=${page}&page[size]=${perPage}`;

        if (params?.search && params.search.trim().length > 0) {
            query += `&filter[search][name_or_partner_name_cont]=${encodeURIComponent(params.search.trim())}`;
        }

        return this.http.get(query, 'admin');
    }

    createCommunity(payload: unknown): Observable<unknown> {
        return this.http.post(COMMUNITIES_URL, payload, 'admin');
    }

    updateCommunity(id: string, payload: unknown): Observable<unknown> {
        return this.http.patch(`${COMMUNITIES_URL}/${id}`, payload, 'admin');
    }

    deleteCommunity(id: string): Observable<unknown> {
        return this.http.delete(`${COMMUNITIES_URL}/${id}`, 'admin');
    }
}

